export default __webpack_public_path__ + "static/media/chateau.8cb83a5d.jpg";